// useAuthStatus.ts
import { useAuth } from './useAuth';

export function useAuthStatus() {
  const { user, loading } = useAuth();

  // Return isAuthenticated status and loading state
  return {
    isAuthenticated: !!user,
    isLoading: loading,
  };
}
